/**
 * @Author: v_huangyongxing@baidu.com
 * @Date: 2023-02-21 13:51:12
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2024-12-20 14:05:18
 * @FilePath: /m-anquan-baidu-com/src/containers/about/index.js
 * @Description: 
 */
/**
 * @file 关于我们
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ProductTitle from '../../components/ProductTitle';
import './index.less';

export default class About extends Component {
    static propTypes = {
        match: PropTypes.object,
        history: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            aboutType: this.props.match.params.type || 'us',
            overstep: false
        };
    }

    componentWillMount() {
        if (this.isPC()) {
            location.href = `/about/${this.state.aboutType}`;
        }
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 600);
        window.addEventListener('scroll', () => this.sildeTabTop());

    }

    componentWillUnmount() {
        window.removeEventListener('scroll', () => this.sildeTabTop());
    }

    sildeTabTop() {
        const aboutBoxBanner = this.aboutBoxBanner;
        let docScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (aboutBoxBanner) {
            if (docScrollTop >= aboutBoxBanner.offsetHeight) {
                this.setState({
                    overstep: true
                });
            } else {
                this.setState({
                    overstep: false
                });
            }
        }
    }

    render() {
        let {aboutType, overstep} = this.state;
        let tabData = [
            {value: '了解我们', name: 'us'},
            {value: '联系我们', name: 'contacts'}
        ];

        return (
            <div className={'xbu-about'}>
                {overstep ? <div style={{height: '7rem'}} /> : null}
                <div>

                </div>
                <div className={overstep ? 'about-banner-box about-fixed' : 'about-banner-box'}>
                    <div className={'about-banner'} ref={el => this.aboutBoxBanner = el}>
                        <h1>
                            成为深谙业务的
                            <br />
                            智能世界安全领导者
                        </h1>
                        <img
                            src={require('../../asset/image/about/guanyuwomen_wap.svg')}
                            alt={'banner'}
                            width={'100%'}
                        />
                    </div>
                    <div className={'about-tab'}>
                        <div className={'about-slide'}>
                            <ul>
                                {tabData.map((item, index) => {
                                    return <li
                                        className={item.name === aboutType ? 'on' : ''}
                                        key={index}
                                        onClick={() => {
                                            this.setState({
                                                tabIndex: index,
                                                aboutType: item.name
                                            });
                                            this.props.history.push(`/about/${item.name}`);

                                            if (this.state.overstep) {
                                                document.documentElement.scrollTop
                                                    = document.body.scrollTop
                                                    = this.aboutBoxBanner.offsetHeight;
                                            }
                                        }}
                                    >
                                        {item.value}
                                    </li>;
                                })}
                            </ul>
                        </div>
                        <div className={'tab-shadow'} />
                        <div className={'tab-shadow'} />
                    </div>
                </div>
                <div className={'about-con'}>
                    {aboutType === 'us'
                        ? <div className={'about-us'}>
                            {/* <h3>23年安全实践，5大安全矩阵</h3>
                            <div className={'resume-icon just-bet'}>
                                <div>
                                    <img src={require('../../asset/image/about/aianquan_140.svg')} alt="AI安全" />
                                    <span>AI安全</span>
                                </div>
                                <div>
                                    <img src={require('../../asset/image/about/yidonganquan_140.svg')} alt="移动安全" />
                                    <span>移动安全</span>
                                </div>
                                <div>
                                    <img src={require('../../asset/image/about/yunanquan_140.svg')} alt="云安全" />
                                    <span>云安全</span>
                                </div>
                                <div>
                                    <img src={require('../../asset/image/about/shujuanquan_140.svg')} alt="数据安全" />
                                    <span>数据安全</span>
                                </div>
                                <div>
                                    <img src={require('../../asset/image/about/yewuanquan_140.svg')} alt="业务安全" />
                                    <span>业务安全</span>
                                </div>
                            </div>
                            <p>
                                {'百度安全是百度公司旗下，以AI为核心、大数据为基础打造的安全品牌，是百度在互联网安全23年安全实践'
                                    + '的总结与提炼。首创AI安全Security、Saftety、Privacy三大维度，研究方向涵盖AI安全、云安全、'
                                    + '数据安全与隐私保护、物联网安全等前沿安全领域；业务覆盖百度各种复杂业务场景，同时面向安全生态、'
                                    + '商业合作伙伴输出安全产品与行业一体化解决方案，全面护航AI时代云上安全各大业务场景。在近五年的'
                                    + '国际安全顶会中，论文发表数量在国内科技公司中位列第一。面向行业生态，一方面，发挥技术能力打击'
                                    + '包括电信网络诈骗、赌博、隐私窃取在内的各类违法犯罪行为，协助公安机关破案数百起，'
                                    + '涉案金额达数亿元人民币，一方面，以技术开源、专利共享、标准驱动为理念，联合生态合作'
                                    + '伙伴推动AI时代的安全生态建设。'}
                            </p>
                            <h3>7种武器，赋能AI时代</h3>
                            <div className={'resume-icon plan7'}>
                                <div>
                                    <img src={require('../../asset/image/about/KARMA_140.svg')} alt="KARMA" />
                                    <span>KARMA</span>
                                </div>
                                <div>
                                    <img src={require('../../asset/image/about/MesaLink_140.svg')} alt="MesaLink" />
                                    <span>MesaLink</span>
                                </div>
                                <div>
                                    <img src={require('../../asset/image/about/MesaLock_140.svg')} alt="MesaLock" />
                                    <span>MesaLock</span>
                                </div>
                                <div>
                                    <img src={require('../../asset/image/about/MesaTEE_140.svg')} alt="MesaTEE" />
                                    <span>MesaTEE</span>
                                </div>
                            </div>
                            <div className={'resume-icon plan7'}>
                                <div>
                                    <img src={require('../../asset/image/about/OpenRASP_140.svg')} alt="OpenRASP" />
                                    <span>OpenRASP</span>
                                </div>
                                <div>
                                    <img src={require('../../asset/image/about/advbox_140.svg')} alt="AdvBox" />
                                    <span>AdvBox</span>
                                </div>
                                <div>
                                    <img src={require('../../asset/image/about/HugeGraph_140.svg')} alt="HugeGraph" />
                                    <span>HugeGraph</span>
                                </div>
                                <div>
                                </div>
                            </div>
                            <p>
                                面对AI时代层出不穷且日益复杂的生态安全问题，百度安全倡导新一代技术研发与开源，迄今已实现多项AI安全
                                核心技术的突破，“七种武器”———KARMA系统自适应热修复、MesaLink TLS下一代安全通信库、
                                MesaLock Linux内存安全操作系统、MesaTEE下一代可信安全计算服务、OpenRASP下一代云端安全防护系统、
                                AdvBox对抗样本工具包和HugeGraph大规模图数据库，全面覆盖云管端以及大数据和算法层面的一系列安全风险
                                问题，赋能AI时代的安全生态。
                            </p>
                            <h3>开源共享，共建生态</h3>
                            <p style={{marginBottom: '.8rem'}}>
                                百度安全以技术开源、专利共享、标准驱动为理念，联合互联网公司、安全厂商、终端制造商、高校及科研机构
                                ， 推动AI时代的安全生态建设，让全行业享受更安全的AI所来带来的变革。
                            </p> */}
                            <p style={{marginBottom: '.8rem'}}>
                                百度安全是百度公司旗下，以AI为核心打造的安全品牌，是百度二十四年安全实践的总结与提炼，致力于成为深谙业务的智能世界安全
                                领导者。基于基础安全、数据安全、业务安全、车与IoT安全四大产品矩阵，百度安全业务覆盖百度各种复杂业务场景，同时面向合作
                                伙伴输出安全产品与行业一体化解决方案，涵盖泛科技、智慧金融、智慧工业、智慧汽车、智慧政务等领域，全面探索AI时代的新实践、
                                新范式。
                            </p>
                            <p>
                                面向行业生态，一方面，发挥技术能力打击包括电信网络诈骗、赌博、隐私窃取在内的各类违法犯罪行为，协助公安机关破案数百起，
                                涉案金额达数亿元人民币，一方面，秉承技术开源、标准驱动理念，联合生态合作伙伴推动AI时代的安全生态建设。
                            </p>
                            <div className={'about-bot'}>
                                <img src={require('../../asset/image/about/1.jpg')} alt="百度安全" />
                                <img src={require('../../asset/image/about/2.png')} alt="百度安全" />
                                <img src={require('../../asset/image/about/3.png')} alt="百度安全" />
                            </div>
                        </div>
                        : null
                    }
                    {aboutType === 'contacts'
                        ? <div className={'about-contacts'}>
                            <ProductTitle title={'商务咨询'} />
                            <div className={'details-mod mb40 about-way'} style={{paddingLeft: '1.2rem'}}>
                                <div className={'mb40'}>
                                    <span className={'aboutTextLeft'}>致电</span>
                                    <a href="tel://400-805-4999">400-805-4999</a>
                                </div>
                                <div>
                                    <span className={'aboutTextLeft'}>邮箱</span>
                                    <a href="mailto:anquan_business@baidu.com" target="">anquan_business@baidu.com</a>
                                </div>
                            </div>
                            <div className={'details-mod align-center'}>
                                <div className={'ml160'}>
                                    <img
                                        src={require('../../asset/image/about/shenqingshiyongi_140.svg')}
                                        style={{width: '1.4rem', height: '1.4rem'}}
                                        alt="申请试用"
                                    />
                                </div>
                                <div className={'ml140'}>
                                    <a href="/m/apply" className={'m-btn mb40'}>申请试用</a>
                                    <div className={'weak-hint'}>提交需求，专人回复</div>
                                </div>
                            </div>
                            <ProductTitle title={'建议/反馈'} />
                            <div className={'details-mod align-center mb40'}>
                                <div className={'ml160'}>
                                    <img
                                        src={require('../../asset/image/about/liuyanjianyi_140.svg')}
                                        style={{width: '1.4rem', height: '1.4rem'}}
                                        alt="留言建议"
                                    />
                                </div>
                                <div className={'ml140'}>
                                    <a
                                        href={'https://zhiqiu.baidu.com/imcswebchat/h5chat/h5message'
                                            + '.html?id=7360&token'
                                            + '=ou5qte56q1a5nrsd2i7bvvo50to16s81&domainID=baiduanquan'}
                                        className={'m-btn mb40'}
                                        target={'_blank'}
                                    >
                                        留言建议
                                    </a>
                                    <div className={'weak-hint'}>我们期待您的建议</div>
                                </div>
                            </div>
                            <div className={'details-mod align-center'}>
                                <div className={'ml160'}>
                                    <img
                                        src={require('../../asset/image/about/zhinnegkefu_140.svg')}
                                        style={{width: '1.4rem', height: '1.4rem'}}
                                        alt="只能客服"
                                    />
                                </div>
                                <div className={'ml140'}>
                                    <a
                                        href={'https://zhiqiu.baidu.com/imcswebchat/roulette/in?id=26333'
                                            + '&token=1lhv02nii91bejjb5a4f5u2gfk7skm4k&domainID=baiduanquan&type=1'}
                                        className={'m-btn mb40'}
                                        target={'_blank'}
                                    >
                                        智能客服
                                    </a>
                                    <div className={'weak-hint'}>智能机器人，懂你所想</div>
                                </div>
                            </div>
                            <ProductTitle title={'了解更多'} />
                            <div className={'details-mod align-center mb40'}>
                                <div className={'ml160'}>
                                    <img
                                        src={require('../../asset/image/about/chanpinbankuai_140.svg')}
                                        style={{width: '1.4rem', height: '1.4rem'}}
                                        alt="产品板块"
                                    />
                                </div>
                                <div className={'ml140'}>
                                    <a
                                        href={'/productCenter'}
                                        className={'m-btn mb40'}>
                                        产品板块
                                    </a>
                                    <div className={'weak-hint'}>产品案例、指南、资料</div>
                                </div>
                            </div>
                            <div className={'details-mod align-center'}>
                                <div className={'ml160'}>
                                    <img
                                        src={require('../../asset/image/about/image_QR code_wap.png')}
                                        style={{width: '1.4rem', height: '1.4rem'}}
                                        alt="留言建议"
                                    />
                                </div>
                                <div className={'ml140'}>
                                    <div className={'weak-hint'}>关注我们</div>
                                </div>
                            </div>
                        </div>
                        : null

                    }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/about/index.js